import { DaDeviationOptions } from '@wix/da-editor-tiptap/pkg/extensions/extension-deviation/deviation';
import { PapiDeviation } from '@wix/da-papi-types';
import React from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import UnknownMonoView from './Unknown';
import ImageView from './Image';
import JournalView from './Journal';
import LitView from './Literature';
import CommissionView from './Commission';
import StatusView from './Status';
import TierView from './Tier';
import PollView from './Poll';
import { DeviationDuperbrowseContext } from '../../Duperbrowse';

export interface Props {
  extOptions: DaDeviationOptions;
  deviation: PapiDeviation;
  width: number;
  link?: string;
}

const MonoView: React.FC<Props> = props => {
  const { deviation } = props;
  let View;
  switch (getDeviationType(deviation)) {
    case DeviationTypes.IMAGE:
    case DeviationTypes.PDF:
    case DeviationTypes.FILM:
    case DeviationTypes.ORIGINALS:
      View = ImageView;
      break;
    case DeviationTypes.STATUS:
      View = StatusView;
      break;
    case DeviationTypes.LITERATURE:
      View = LitView;
      break;
    case DeviationTypes.JOURNAL:
      View = JournalView;
      break;
    case DeviationTypes.TIER:
      View = TierView;
      break;
    case DeviationTypes.COMMISSION:
      View = CommissionView;
      break;
    case DeviationTypes.POLL:
      View = PollView;
      break;
    default:
      View = UnknownMonoView;
  }

  if (!deviation) {
    return null;
  }

  return (
    <DeviationDuperbrowseContext
      streamId={`single-${deviation.deviationId}`}
      deviations={[deviation]}
    >
      <View {...props} />
    </DeviationDuperbrowseContext>
  );
};
MonoView.displayName = 'MonoView';

export default MonoView;
